const menu = {
    list() {
        return [{
            "backMenu": [ {
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "公司",
                    "menuJump": "列表",
                    "tableName": "bumen"
                }],
                "menu": "公司管理"
            }, {
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "岗位",
                    "menuJump": "列表",
                    "tableName": "gangwei"
                }],
                "menu": "岗位管理"
            }, {
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "员工",
                    "menuJump": "列表",
                    "tableName": "yuangong"
                }],
                "menu": "员工管理"
            },{
                "child": [{
                    "buttons": ["查看", "修改", "删除", "新增"],
                    "menu": "业绩管理",
                    "menuJump": "列表",
                    "tableName": "yuangongjixiao"
                },{
                    "buttons": ["查看", "修改", "删除", "新增"],
                    "menu": "售后管理",
                    "menuJump": "列表",
                    "tableName": "shouhouyeji"
                },{
                    "buttons": ["查看"],
                    "menu": "有效业绩",
                    "menuJump": "列表",
                    "tableName": "youxiaoyeji"
                },{
                    "buttons": ["查看", "修改", "删除", "新增"],
                    "menu": "支出管理",
                    "menuJump": "列表",
                    "tableName": "gongsizhichu"
                },{
                    "buttons": ["查看", "新增", "修改", "删除"],
                    "menu": "收入管理",
                    "menuJump": "列表",
                    "tableName": "gongsishouru"
                },{
                    "buttons": ["查看"],
                    "menu": "业绩汇总",
                    "menuJump": "列表",
                    "tableName": "shouruhuizong"
                },{
                    "buttons": ["查看"],
                    "menu": "业绩排行",
                    "menuJump": "列表",
                    "tableName": "yejipaihang"
                }],
                "menu": "业绩管理"
            },{
                "child": [{
                    "buttons": ["查看"],
                    "menu": "操作日志",
                    "menuJump": "列表",
                    "tableName": "caozuorizhi"
                }],
                "menu": "操作日志"
            }],
            "frontMenu": [],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "管理员",
            "tableName": "users"
        }, {
            "backMenu": [{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "员工",
                    "menuJump": "列表",
                    "tableName": "yuangong"
                }],
                "menu": "员工管理"
            },{
                "child": [{
                    "buttons": ["查看","新增", "修改", "删除"],
                    "menu": "业绩管理",
                    "menuJump": "列表",
                    "tableName": "yuangongjixiao"
                },{
                    "buttons": ["查看", "新增","修改", "删除"],
                    "menu": "售后管理",
                    "menuJump": "列表",
                    "tableName": "shouhouyeji"
                },{
                    "buttons": ["查看"],
                    "menu": "有效业绩",
                    "menuJump": "列表",
                    "tableName": "youxiaoyeji"
                },{
                    "buttons": ["查看", "新增", "修改", "删除"],
                    "menu": "支出管理",
                    "menuJump": "列表",
                    "tableName": "gongsizhichu"
                },{
                    "buttons": ["查看", "新增", "修改", "删除"],
                    "menu": "收入管理",
                    "menuJump": "列表",
                    "tableName": "gongsishouru"
                },{
                    "buttons": ["查看"],
                    "menu": "业绩汇总",
                    "menuJump": "列表",
                    "tableName": "shouruhuizong"
                },{
                    "buttons": ["查看"],
                    "menu": "业绩排行",
                    "menuJump": "列表",
                    "tableName": "yejipaihang"
                }],
                "menu": "业绩管理"
            }],
            "frontMenu": [],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "公司",
            "tableName": "bumen"
        }, {
            "backMenu": [ {
                "child": [{
                    "buttons": ["查看", "新增"],
                    "menu": "业绩管理",
                    "menuJump": "列表",
                    "tableName": "yuangongjixiao"
                },{
                    "buttons": ["查看",  "新增"],
                    "menu": "售后管理",
                    "menuJump": "列表",
                    "tableName": "shouhouyeji"
                },{
                    "buttons": ["查看"],
                    "menu": "有效业绩",
                    "menuJump": "列表",
                    "tableName": "youxiaoyeji"
                },{
                    "buttons": ["查看"],
                    "menu": "业绩排行",
                    "menuJump": "列表",
                    "tableName": "yejipaihang"
                }],
                "menu": "业绩管理"
            }],
            "frontMenu": [],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "员工",
            "tableName": "yuangong"
        }]
    }
}
export default menu;
